export const valueDoesExist = (value) => {
    return !(value === false || value === "" || value === null || value === undefined);
}
